var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "row data-table",
      class: [_vm.baseClass, { "mb-0": _vm.tableInline }],
    },
    [
      _c(
        "div",
        { staticClass: "col" },
        [
          _vm.filtersSlot || _vm.title
            ? _c(
                "div",
                {
                  ref: "dataFilters",
                  staticClass: "row data-table__filters-wrapper",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _vm.filtersSlot
                        ? _vm._t(
                            "filters",
                            function () {
                              return [
                                _c(
                                  "form",
                                  {
                                    attrs: {
                                      autocomplete: "false",
                                      "data-vv-scope": "form",
                                    },
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onBeforeSearch.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row header mb-2 mb-md-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mt-0 mb-3 mt-sm-0 mb-md-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { class: _vm.titleClass },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t(_vm.title))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column flex-sm-row flex-grow-1 flex-sm-grow-0",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap align-items-center flex-fill flex-sm-grow-0 order-2 order-sm-1",
                                                  },
                                                  [
                                                    _vm._t(
                                                      "filters-buttons",
                                                      null,
                                                      {
                                                        tableFilters:
                                                          _vm.collection.get(
                                                            "filters"
                                                          ),
                                                        search: _vm.onSearch,
                                                        resetSearch:
                                                          _vm.onResetSearch,
                                                        disabled:
                                                          _vm.searchDisabled,
                                                        expanded:
                                                          _vm.expandedFilters,
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center justify-content-between justify-content-sm-end w-100 ml-sm-auto pb-2 pb-sm-0 order-1 order-sm-2",
                                                  },
                                                  [
                                                    _vm.btnClearFilters
                                                      ? _c(
                                                          "button",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.expandedFilters,
                                                                expression:
                                                                  "expandedFilters",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "btn btn-link min-w-auto font-small text-decoration-none z-depth-0 py-sm-0 my-sm-0 m-0 pr-0 pl-0 pl-sm-3",
                                                            attrs: {
                                                              disabled:
                                                                _vm.searchDisabled,
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.onResetSearch.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    `${_vm.titleClearFilters}`
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.collapsibleFilters
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-link min-w-auto font-small text-decoration-none z-depth-0 m-0",
                                                            class: [
                                                              _vm.expandedFilters
                                                                ? "p-0"
                                                                : "pr-0",
                                                            ],
                                                            attrs: {
                                                              disabled:
                                                                _vm.searchDisabled,
                                                              type: "button",
                                                              "data-toggle": "",
                                                              "data-target":
                                                                "#filters",
                                                              "aria-expanded":
                                                                _vm.expandedFilters,
                                                              "aria-controls":
                                                                "filter",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                _vm.expandedFilters =
                                                                  !_vm.expandedFilters
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center flex-nowrap",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "pr-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.expandedFilters
                                                                          ? _vm
                                                                              .btnCollapseFilters
                                                                              .toogle
                                                                              .expanded
                                                                          : _vm
                                                                              .btnCollapseFilters
                                                                              .toogle
                                                                              .collapsed
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas",
                                                                  class: [
                                                                    _vm.expandedFilters
                                                                      ? "fa-minus-square"
                                                                      : "fa-plus-square",
                                                                  ],
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("collapse-transition", [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.expandedFilters,
                                              expression: "expandedFilters",
                                            },
                                          ],
                                          attrs: { id: "filters" },
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-12" },
                                              [
                                                _vm._t("filters-body", null, {
                                                  tableFilters:
                                                    _vm.collection.get(
                                                      "filters"
                                                    ),
                                                  search: _vm.onSearch,
                                                  resetSearch:
                                                    _vm.onResetSearch,
                                                }),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.btnSearchFilters
                                            ? _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 col-sm-auto mx-auto mr-sm-auto ml-sm-0",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row mt-0 mb-4 mt-sm-2 mb-sm-4",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col col-sm-auto",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-main btn-rounded btn-sm btn-block btn-responsive",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.searchDisabled,
                                                                    type: "submit",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          `${_vm.titleSearchFilters}`
                                                                        )
                                                                      ) +
                                                                      "\n                                                "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._t(
                                                            "search-buttons",
                                                            null,
                                                            {
                                                              tableFilters:
                                                                _vm.collection.get(
                                                                  "filters"
                                                                ),
                                                              search:
                                                                _vm.onSearch,
                                                              resetSearch:
                                                                _vm.onResetSearch,
                                                              disabled:
                                                                _vm.searchDisabled,
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                            {
                              tableFilters: _vm.collection.get("filters"),
                              search: _vm.onSearch,
                              resetSearch: _vm.onResetSearch,
                            }
                          )
                        : _vm.title
                        ? _c(
                            "div",
                            { staticClass: "row header mb-2 mb-md-0" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mb-2 mb-md-0 mb-md-3",
                                      class: _vm.titleClass,
                                    },
                                    [_vm._v(_vm._s(_vm.$t(_vm.title)))]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("beforeTable", null, {
            tableFilters: _vm.collection.get("filters"),
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row data-table__table-wrapper" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _vm._t(
                  "title",
                  function () {
                    return [
                      _vm.hasTitleData ||
                      _vm.hasButtonsHeaderSlot ||
                      _vm.canExportData ||
                      _vm.canClearFeatures
                        ? _c(
                            "div",
                            { staticClass: "row data-table__table-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 d-flex align-items-center mb-2",
                                },
                                [
                                  _vm.hasTitleData
                                    ? _c("span", { staticClass: "subtitle" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t(_vm.titleData)) +
                                            "\n                            "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canExportData
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "export-header d-flex flex-row align-items-center justify-content-center",
                                        },
                                        [
                                          _vm.exportFormats.length == 1
                                            ? [
                                                _c(
                                                  "button",
                                                  {
                                                    key: `format-${_vm.exportFormats[0].format}`,
                                                    staticClass:
                                                      "btn btn-link min-w-auto btn-lg p-0 z-depth-0",
                                                    attrs: {
                                                      type: "button",
                                                      disabled:
                                                        _vm.searchDisabled,
                                                      title: _vm.$t(
                                                        `${
                                                          _vm.exportFormats[0]
                                                            .title
                                                            ? _vm
                                                                .exportFormats[0]
                                                                .title
                                                            : _vm
                                                                .exportFormats[0]
                                                                .name
                                                        }`
                                                      ),
                                                      "data-toggle":
                                                        "tooltip-city",
                                                      "data-dismiss": "modal",
                                                      "aria-label": "Format",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return ((evt) =>
                                                          _vm.onExport(
                                                            _vm
                                                              .exportFormats[0],
                                                            evt
                                                          )).apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._m(0)]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "div",
                                                  { staticClass: "btn-group" },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0 btn-sm dropdown-toggle",
                                                        attrs: {
                                                          type: "button",
                                                          title: _vm.$t(
                                                            _vm.titleExportData
                                                          ),
                                                          disabled:
                                                            _vm.searchDisabled,
                                                          "data-toggle":
                                                            "dropdown",
                                                          "aria-haspopup":
                                                            "true",
                                                          "aria-expanded":
                                                            "false",
                                                        },
                                                      },
                                                      [_vm._m(1)]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-menu",
                                                      },
                                                      _vm._l(
                                                        _vm.exportFormats,
                                                        function (
                                                          cfgFormat,
                                                          idx
                                                        ) {
                                                          return _c(
                                                            "button",
                                                            {
                                                              key: `format-${cfgFormat.format}-${idx}`,
                                                              staticClass:
                                                                "dropdown-item btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.searchDisabled,
                                                                type: "button",
                                                                "data-dismiss":
                                                                  "modal",
                                                                "aria-label":
                                                                  "Format",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return ((
                                                                      evt
                                                                    ) =>
                                                                      _vm.onExport(
                                                                        cfgFormat,
                                                                        evt
                                                                      )).apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "icon text-secondary-color",
                                                                },
                                                                [
                                                                  cfgFormat.img
                                                                    ? [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "export",
                                                                            attrs:
                                                                              {
                                                                                src: _vm.getImgUrl(
                                                                                  cfgFormat.img
                                                                                ),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            class:
                                                                              [
                                                                                "export",
                                                                                cfgFormat.icon
                                                                                  ? cfgFormat.icon
                                                                                  : "fas fa-file",
                                                                              ],
                                                                          }
                                                                        ),
                                                                      ],
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        cfgFormat.name
                                                                      )
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ],
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.exportTypedFormats,
                                            function (cfgFormat, idx) {
                                              return _c(
                                                "button",
                                                {
                                                  key: `format-typed-${idx}`,
                                                  staticClass:
                                                    "btn btn-link min-w-auto text-decoration-none p-0 z-depth-0",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      cfgFormat.title
                                                        ? cfgFormat.title
                                                        : cfgFormat.name
                                                    ),
                                                    "data-toggle":
                                                      "tooltip-city",
                                                    disabled:
                                                      _vm.searchDisabled,
                                                    type: "button",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.onExport(
                                                        cfgFormat
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  cfgFormat.img
                                                    ? [
                                                        _c("img", {
                                                          staticClass: "export",
                                                          attrs: {
                                                            src: _vm.getImgUrl(
                                                              cfgFormat.img
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    : cfgFormat.icon
                                                    ? [
                                                        _c("i", {
                                                          class: [
                                                            "export",
                                                            cfgFormat.icon,
                                                          ],
                                                        }),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._t("buttons-header", null, {
                                    queryParams: _vm.queryParams(),
                                    total: _vm.totalRowCount,
                                    disabled: _vm.searchDisabled,
                                  }),
                                  _vm._v(" "),
                                  _vm.canClearFeatures
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-row align-items-center justify-content-center",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-link min-w-auto text-decoration-none p-0 z-depth-0",
                                              attrs: {
                                                title: _vm.$t(
                                                  _vm.titleClearFeatures
                                                ),
                                                "data-toggle": "tooltip-city",
                                                disabled: _vm.searchDisabled,
                                                type: "button",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.onClearFeatures.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                class: _vm.classClearFeatures,
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  { add: _vm.onAddItem }
                ),
                _vm._v(" "),
                _vm.selectedRowCount && !_vm.disableSelectInfo
                  ? _c(
                      "div",
                      {
                        staticClass: "vgt-selection-info-row clearfix",
                        class: _vm.selectionInfoClass,
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.selectionInfo) +
                            "\n                    "
                        ),
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.unselectAllInternal(true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.clearSelectionText) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "vgt-selection-info-row__actions vgt-pull-right",
                          },
                          [_vm._t("selected-row-actions")],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      { "city-table-wrapper": !_vm.tableInline },
                      _vm.tableWrapperClass,
                    ],
                  },
                  [
                    _c(
                      "table",
                      {
                        staticClass: "table",
                        class: [
                          _vm.fullTableClass,
                          { loading: _vm.isLoading() },
                        ],
                      },
                      [
                        _c("thead", [
                          _c(
                            "tr",
                            { class: _vm.rowHeaderClass },
                            [
                              _vm.selectable
                                ? _c("th", { staticClass: "checkbox-col" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-check city-form-check pl-0",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "th-checkbox",
                                          },
                                          domProps: {
                                            checked: _vm.allSelected,
                                            indeterminate:
                                              _vm.allSelectedIndeterminate,
                                          },
                                          on: { change: _vm.toggleSelectAll },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "form-check-label",
                                          attrs: { for: "th-checkbox" },
                                        }),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                _vm.activeColumns,
                                function (column, index) {
                                  return _c(
                                    "th",
                                    {
                                      key: `${_vm.cpName}th-${index}`,
                                      class: [
                                        "align-middle",
                                        {
                                          "text-nowrap":
                                            column.nowrap == undefined
                                              ? true
                                              : !!column.nowrap,
                                        },
                                        (_vm.isFunction(column.class)
                                          ? column.class()
                                          : column.class) ?? "",
                                      ],
                                      attrs: { scope: "col" },
                                    },
                                    [
                                      column.sortable
                                        ? _c(
                                            "a",
                                            {
                                              class: [
                                                {
                                                  "text-break-normal":
                                                    column.nowrap == undefined
                                                      ? false
                                                      : !!!column.nowrap,
                                                  "": _vm.collection.isOrderedBy(
                                                    column.field
                                                  ),
                                                },
                                              ],
                                              attrs: {
                                                "data-toggle": "tooltip-city",
                                                title: _vm.titleSortable(
                                                  _vm.$t(
                                                    column.label_tooltip ||
                                                      column.label
                                                  )
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.collection.toggleSortable(
                                                    column.field
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(column.label)
                                                    ) +
                                                    "\n                                            "
                                                ),
                                                _vm.collection.isOrderedBy(
                                                  column.field
                                                )
                                                  ? _c("i", {
                                                      staticClass: "pl-1 fas",
                                                      class: _vm.sortIcon,
                                                    })
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(_vm.$t(column.label)) +
                                                "\n                                    "
                                            ),
                                          ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm.hasResult
                              ? [
                                  _vm._l(
                                    _vm.collection.items,
                                    function (row, index) {
                                      return [
                                        _c(
                                          "tr",
                                          {
                                            key: `${_vm.cpName}row-${
                                              row.id || "index-" + index
                                            }`,
                                            class: _vm.rowBodyClass,
                                            on: {
                                              click: function ($event) {
                                                return _vm.onRowClicked(
                                                  row,
                                                  index,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.selectable
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "checkbox-col",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.onCheckboxClicked(
                                                          row,
                                                          index,
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check city-form-check pl-0",
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "form-check-input",
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              row.vgtSelected ||
                                                              _vm.selRows.indexOf(
                                                                row.id
                                                              ) > -1,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "form-check-label",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._t("body", null, {
                                              fieldColumns: _vm.fieldColumns,
                                              actionColumns: _vm.actionColumns,
                                              columns: _vm.columns,
                                              row: row,
                                              index: index,
                                              remove: _vm.onRemove,
                                              add: _vm.onAddItem,
                                              search: _vm.onSearch,
                                              resetSearch: _vm.onResetSearch,
                                              hasChild:
                                                _vm.hasChildConfiguration &&
                                                _vm.hasRowChildValue(
                                                  row,
                                                  _vm.childProperty
                                                ),
                                              childId: _vm.idRowChild(
                                                row,
                                                index
                                              ),
                                            }),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.hasChildConfiguration &&
                                        _vm.hasRowChildValue(
                                          row,
                                          _vm.childProperty
                                        )
                                          ? [
                                              _c(
                                                "tr",
                                                {
                                                  key: `${
                                                    _vm.cpName
                                                  }row-group-${
                                                    row.id || "index-" + index
                                                  }`,
                                                  staticClass: "collapse",
                                                  attrs: {
                                                    id: _vm.idRowChild(
                                                      row,
                                                      index
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        colspan:
                                                          _vm.columns.length,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "table table-child",
                                                          class:
                                                            _vm.childTableClass,
                                                          attrs: {
                                                            "data-detail-view":
                                                              "",
                                                          },
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c(
                                                              "tr",
                                                              _vm._l(
                                                                _vm.activeChildColumns,
                                                                function (
                                                                  column,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "th",
                                                                    {
                                                                      key: `${_vm.cpName}row-th-${index}`,
                                                                      class: [
                                                                        "align-middle",
                                                                        {
                                                                          "text-nowrap":
                                                                            column.nowrap ==
                                                                            undefined
                                                                              ? true
                                                                              : !!column.nowrap,
                                                                        },
                                                                        (_vm.isFunction(
                                                                          column.class
                                                                        )
                                                                          ? column.class()
                                                                          : column.class) ??
                                                                          "",
                                                                      ],
                                                                      attrs: {
                                                                        scope:
                                                                          "col",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                    " +
                                                                              _vm._s(
                                                                                _vm.isFunction(
                                                                                  column.label
                                                                                )
                                                                                  ? column.label(
                                                                                      row
                                                                                    )
                                                                                  : _vm.$t(
                                                                                      column.label
                                                                                    )
                                                                              ) +
                                                                              "\n                                                                "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            _vm._l(
                                                              row[
                                                                _vm
                                                                  .childProperty
                                                              ],
                                                              function (
                                                                rowChild,
                                                                keyChild,
                                                                rowChildIndex
                                                              ) {
                                                                return _c(
                                                                  "tr",
                                                                  {
                                                                    key: `${
                                                                      _vm.cpName
                                                                    }row-group-child-${index}-${
                                                                      rowChild.id ||
                                                                      rowChildIndex
                                                                    }`,
                                                                  },
                                                                  [
                                                                    _vm._t(
                                                                      "row-child",
                                                                      null,
                                                                      {
                                                                        rowParent:
                                                                          row,
                                                                        indexParent:
                                                                          index,
                                                                        columns:
                                                                          _vm.activeChildColumns,
                                                                        row: rowChild,
                                                                        property:
                                                                          keyChild,
                                                                        index:
                                                                          rowChildIndex ??
                                                                          keyChild,
                                                                        rowId:
                                                                          _vm.idRowChild(
                                                                            row,
                                                                            index
                                                                          ),
                                                                      }
                                                                    ),
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ]
                              : _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: _vm.columns.length },
                                    },
                                    [
                                      _vm.isLoading()
                                        ? [
                                            _vm.showSpinner
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center align-items-center",
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "spinner-border spinner-border-sm",
                                                        attrs: {
                                                          role: "status",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                _vm.loadingMsg
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(_vm.loadingMsg)
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ],
                                          ]
                                        : _c("div", {}, [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(_vm.$t(_vm.noDataText)) +
                                                "\n                                    "
                                            ),
                                          ]),
                                    ],
                                    2
                                  ),
                                ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.showPagination
            ? _c("div", { staticClass: "row data-table__pagination-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("pagination", {
                      attrs: {
                        collection: _vm.collection,
                        loading: _vm.isLoading(),
                        "show-pagination-info":
                          _vm.pagination.showPaginationInfo,
                        "show-per-page": _vm.pagination.showPerPage,
                        "pagination-info-class":
                          _vm.pagination.paginationInfoClass,
                        "pagination-component-class":
                          _vm.pagination.paginationComponentClass,
                        "pagination-info-per-page-class":
                          _vm.pagination.paginationInfoPerPageClass,
                        "pagination-info-template":
                          _vm.pagination.paginationInfoTemplate,
                        "pagination-info-no-data-template":
                          _vm.pagination.paginationNoDataInfoTemplate,
                        "pagination-info-prefix-per-page-template":
                          _vm.pagination.paginationInfoPrefixPerPageTemplate,
                        "pagination-info-suffix-per-page-template":
                          _vm.pagination.paginationInfoSuffixPerPageTemplate,
                      },
                      on: {
                        "update:collection": function ($event) {
                          _vm.collection = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", {}, [_c("i", { staticClass: "fas fa-download" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "text-secondary-color" }, [
      _c("i", { staticClass: "fas fa-download" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }